import { FC, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { ILocalization } from '../../localization/definitions/types';
import { RootState, getCurrentUser } from '../../store';
import { savePersonalPicture } from '../../store/actions';
import { PROFILE_PICTURE_FILE_SIZE_LIMIT } from '../shared/UploadFile/uploadFileConstants';
import { getFileCloneWithFixedMissingMimeType } from '../../utils/file';

interface InfoProps {
    localization: ILocalization;

    getCurrentUser: () => Promise<void>;
    savePersonalPicture: (profilePicture: File | null) => void;
}

const ProfilePictureUpload: FC<InfoProps> = (props) => {
    const [file, setFile] = useState<File>();

    const profilePictureUploadLocalization =
        props.localization.localizationStrings.susy.profile
            .profilePictureUpload;

    useEffect(() => {
        if (!file) {
            return;
        }
    }, [file]);

    const onFileSelected = async (files: FileList | null) => {
        if (!files) {
            return;
        }
        const file = getFileCloneWithFixedMissingMimeType(files[0]);

        if (file.size > PROFILE_PICTURE_FILE_SIZE_LIMIT) {
            alert(profilePictureUploadLocalization.alertText);
            return;
        }

        await props.savePersonalPicture(file);
        setFile(file);
        await props.getCurrentUser();
    };

    return (
        <>
            {/* Stop propagation is needed because dropdown.Item is going to be triggered because it is below this button. Also, because label acting is on behalf of */}
            {/* input, both have to have propagation to stop, so dropdown is not triggered */}
            <div className='profile-sidebar-picture-upload d-flex justify-content-between '>
                <input
                    className='form-check-input'
                    type='file'
                    id='uploadFile'
                    onClick={(e) => {
                        e.stopPropagation();
                    }}
                    onChange={(e) => onFileSelected(e.target.files)}
                />
                <label
                    className='form-check-label'
                    htmlFor='uploadFile'
                    onClick={(e) => {
                        e.stopPropagation();
                    }}
                >
                    <svg
                        width='1em'
                        height='1em'
                        viewBox='0 0 16 16'
                        className='bi bi-person-bounding-box'
                        fill='currentColor'
                        xmlns='http://www.w3.org/2000/svg'
                    >
                        <path
                            fillRule='evenodd'
                            d='M1.5 1a.5.5 0 0 0-.5.5v3a.5.5 0 0 1-1 0v-3A1.5 1.5 0 0 1 1.5 0h3a.5.5 0 0 1 0 1h-3zM11 .5a.5.5 0 0 1 .5-.5h3A1.5 1.5 0 0 1 16 1.5v3a.5.5 0 0 1-1 0v-3a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 1-.5-.5zM.5 11a.5.5 0 0 1 .5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 1 0 1h-3A1.5 1.5 0 0 1 0 14.5v-3a.5.5 0 0 1 .5-.5zm15 0a.5.5 0 0 1 .5.5v3a1.5 1.5 0 0 1-1.5 1.5h-3a.5.5 0 0 1 0-1h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 1 .5-.5z'
                        />
                        <path
                            fillRule='evenodd'
                            d='M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z'
                        />
                    </svg>
                    {profilePictureUploadLocalization.changePictureButton}
                </label>
            </div>
        </>
    );
};

const mapStateToProps = (state: RootState) => ({
    localization: state.localization,
});

export default connect(mapStateToProps, {
    savePersonalPicture,
    getCurrentUser,
})(ProfilePictureUpload);
